import React, { ChangeEventHandler } from 'react';

const SelectAll = ({ onChange }: { onChange: ChangeEventHandler }) => {
  return (
    <div className="react-grid-checkbox-container checkbox-align">
      <input
        className="react-grid-checkbox"
        type="checkbox"
        name="select-all-checkbox"
        id="select-all-checkbox"
        onChange={onChange}
      />
      <label htmlFor="select-all-checkbox" className="react-grid-checkbox-label" />
    </div>
  );
};

export default SelectAll;
